/*
 * @Autor: hansong27
 * @Email: hansong27@jd.com
 * @Description:
 * @CreateDate: Do not edit
 * @LastEditors: hansong27
 */
import { colorHttp } from "@/request/colorRequest";

/**
 * @desc 获取组织树
 */
export const tenantListTree = (params?: any, options?: any) =>
    // colorHttp.post('tenantListTree', params);
    colorHttp.post("bd.user.tenantListTree", params);
/**
 * @desc 获取用户信息
 */
export const getCookie = (params?: any, options?: any) =>
    colorHttp.post("getCookie", params);
/**
 * @desc 获取组织
 */
export const orgTree = (params?: any, options?: any) =>
    colorHttp.post("orgTree", params);
/**
 * @desc 查询用户信息
 */
export const layoutInfo = (params?: any, options?: any) =>
    colorHttp.post("layoutInfo", params);
/**
 * @desc 判断是否在一级租户下
 */
export const checkGray = (params?: any, options?: any) =>
    colorHttp.post("checkGray", params);

export const switchTenant = (params?: any) =>
    colorHttp.post("bd.user.switchTenantCode", params);
